import React from "react";
import Cart from "./Cart/Cart";

const CartPages = () => {
  return (
    <div>
      <Cart />
    </div>
  );
};

export default CartPages;
